import { CustomDesignItemType } from '@iupics-components/models/custom-design';
import * as IBAN from 'iban';
export enum InputInfoSource {
  QR = 'QR',
  BVR = 'BVR',
}
const regexPostalCode = new Map();

export class InputInfo {
  IBAN: string;
  QRIBAN: string;
  isSCOR: boolean;
  vendorName: string;
  address1: string;
  address2: string;
  postalCode: string;
  city: string;
  currency: string;
  amountToPay: number;
  xxReference: string;
  bankAccountId: string;
  bvr: string;
  vendorRef: string;
  warningvendorRefQr = false;
  warningQRR = false;
  countryCode: string;
  countryName: string;
  errors = [];
  logicalErrors = 0;
  logicalWarnings = 0;
  isCorrect = false;
  infoSource: InputInfoSource;
  constructor(info: string[]) {
    if (info.filter((l) => l.length > 0).length === 1) {
      this.setInfoFromBVR(info[0].replace(/ /g, ''));
    } else {
      this.setInfoFromQR(info);
    }
    if (this.errors.length === 0) {
      this.isCorrect = true;
    }
    regexPostalCode.set(
      'GB',
      /GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}/
    );
    regexPostalCode.set('JE', /JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/);
    regexPostalCode.set('GG', /GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/);
    regexPostalCode.set('IM', /IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}/);
    regexPostalCode.set('US', /\d{5}([ \-]\d{4})?/);
    regexPostalCode.set('CA', /[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d/);
    regexPostalCode.set('DE', /\d{5}/);
    regexPostalCode.set('JP', /\d{3}-\d{4}/);
    regexPostalCode.set('FR', /\d{2}[ ]?\d{3}/);
    regexPostalCode.set('AU', /\d{4}/);
    regexPostalCode.set('IT', /\d{5}/);
    regexPostalCode.set('CH', /\d{4}/);
    regexPostalCode.set('AT', /\d{4}/);
    regexPostalCode.set('ES', /\d{5}/);
    regexPostalCode.set('NL', /\d{4}[ ]?[A-Z]{2}/);
    regexPostalCode.set('BE', /\d{4}/);
    regexPostalCode.set('DK', /\d{4}/);
    regexPostalCode.set('SE', /\d{3}[ ]?\d{2}/);
    regexPostalCode.set('NO', /\d{4}/);
    regexPostalCode.set('BR', /\d{5}[\-]?\d{3}/);
    regexPostalCode.set('PT', /\d{4}([\-]\d{3})?/);
    regexPostalCode.set('FI', /\d{5}/);
    regexPostalCode.set('AX', /22\d{3}/);
    regexPostalCode.set('KR', /\d{3}[\-]\d{3}/);
    regexPostalCode.set('CN', /\d{6}/);
    regexPostalCode.set('TW', /\d{3}(\d{2})?/);
    regexPostalCode.set('SG', /\d{6}/);
    regexPostalCode.set('DZ', /\d{5}/);
    regexPostalCode.set('AD', /AD\d{3}/);
    regexPostalCode.set('AR', /([A-HJ-NP-Z])?\d{4}([A-Z]{3})?/);
    regexPostalCode.set('AM', /(37)?\d{4}/);
    regexPostalCode.set('AZ', /\d{4}/);
    regexPostalCode.set('BH', /((1[0-2]|[2-9])\d{2})?/);
    regexPostalCode.set('BD', /\d{4}/);
    regexPostalCode.set('BB', /(BB\d{5})?/);
    regexPostalCode.set('BY', /\d{6}/);
    regexPostalCode.set('BM', /[A-Z]{2}[ ]?[A-Z0-9]{2}/);
    regexPostalCode.set('BA', /\d{5}/);
    regexPostalCode.set('IO', /BBND 1ZZ/);
    regexPostalCode.set('BN', /[A-Z]{2}[ ]?\d{4}/);
    regexPostalCode.set('BG', /\d{4}/);
    regexPostalCode.set('KH', /\d{5}/);
    regexPostalCode.set('CV', /\d{4}/);
    regexPostalCode.set('CL', /\d{7}/);
    regexPostalCode.set('CR', /\d{4,5}|\d{3}-\d{4}/);
    regexPostalCode.set('HR', /\d{5}/);
    regexPostalCode.set('CY', /\d{4}/);
    regexPostalCode.set('CZ', /\d{3}[ ]?\d{2}/);
    regexPostalCode.set('DO', /\d{5}/);
    regexPostalCode.set('EC', /([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?/);
    regexPostalCode.set('EG', /\d{5}/);
    regexPostalCode.set('EE', /\d{5}/);
    regexPostalCode.set('FO', /\d{3}/);
    regexPostalCode.set('GE', /\d{4}/);
    regexPostalCode.set('GR', /\d{3}[ ]?\d{2}/);
    regexPostalCode.set('GL', /39\d{2}/);
    regexPostalCode.set('GT', /\d{5}/);
    regexPostalCode.set('HT', /\d{4}/);
    regexPostalCode.set('HN', /(?:\d{5})?/);
    regexPostalCode.set('HU', /\d{4}/);
    regexPostalCode.set('IS', /\d{3}/);
    regexPostalCode.set('IN', /\d{6}/);
    regexPostalCode.set('ID', /\d{5}/);
    regexPostalCode.set('IL', /\d{5}/);
    regexPostalCode.set('JO', /\d{5}/);
    regexPostalCode.set('KZ', /\d{6}/);
    regexPostalCode.set('KE', /\d{5}/);
    regexPostalCode.set('KW', /\d{5}/);
    regexPostalCode.set('LA', /\d{5}/);
    regexPostalCode.set('LV', /\d{4}/);
    regexPostalCode.set('LB', /(\d{4}([ ]?\d{4})?)?/);
    regexPostalCode.set('LI', /(948[5-9])|(949[0-7])/);
    regexPostalCode.set('LT', /\d{5}/);
    regexPostalCode.set('LU', /\d{4}/);
    regexPostalCode.set('MK', /\d{4}/);
    regexPostalCode.set('MY', /\d{5}/);
    regexPostalCode.set('MV', /\d{5}/);
    regexPostalCode.set('MT', /[A-Z]{3}[ ]?\d{2,4}/);
    regexPostalCode.set('MU', /(\d{3}[A-Z]{2}\d{3})?/);
    regexPostalCode.set('MX', /\d{5}/);
    regexPostalCode.set('MD', /\d{4}/);
    regexPostalCode.set('MC', /980\d{2}/);
    regexPostalCode.set('MA', /\d{5}/);
    regexPostalCode.set('NP', /\d{5}/);
    regexPostalCode.set('NZ', /\d{4}/);
    regexPostalCode.set('NI', /((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?/);
    regexPostalCode.set('NG', /(\d{6})?/);
    regexPostalCode.set('OM', /(PC )?\d{3}/);
    regexPostalCode.set('PK', /\d{5}/);
    regexPostalCode.set('PY', /\d{4}/);
    regexPostalCode.set('PH', /\d{4}/);
    regexPostalCode.set('PL', /\d{2}-\d{3}/);
    regexPostalCode.set('PR', /00[679]\d{2}([ \-]\d{4})?/);
    regexPostalCode.set('RO', /\d{6}/);
    regexPostalCode.set('RU', /\d{6}/);
    regexPostalCode.set('SM', /4789\d/);
    regexPostalCode.set('SA', /\d{5}/);
    regexPostalCode.set('SN', /\d{5}/);
    regexPostalCode.set('SK', /\d{3}[ ]?\d{2}/);
    regexPostalCode.set('SI', /\d{4}/);
    regexPostalCode.set('ZA', /\d{4}/);
    regexPostalCode.set('LK', /\d{5}/);
    regexPostalCode.set('TJ', /\d{6}/);
    regexPostalCode.set('TH', /\d{5}/);
    regexPostalCode.set('TN', /\d{4}/);
    regexPostalCode.set('TR', /\d{5}/);
    regexPostalCode.set('TM', /\d{6}/);
    regexPostalCode.set('UA', /\d{5}/);
    regexPostalCode.set('UY', /\d{5}/);
    regexPostalCode.set('UZ', /\d{6}/);
    regexPostalCode.set('VA', /00120/);
    regexPostalCode.set('VE', /\d{4}/);
    regexPostalCode.set('ZM', /\d{5}/);
    regexPostalCode.set('AS', /96799/);
    regexPostalCode.set('CC', /6799/);
    regexPostalCode.set('CK', /\d{4}/);
    regexPostalCode.set('RS', /\d{6}/);
    regexPostalCode.set('ME', /8\d{4}/);
    regexPostalCode.set('CS', /\d{5}/);
    regexPostalCode.set('YU', /\d{5}/);
    regexPostalCode.set('CX', /6798/);
    regexPostalCode.set('ET', /\d{4}/);
    regexPostalCode.set('FK', /FIQQ 1ZZ/);
    regexPostalCode.set('NF', /2899/);
    regexPostalCode.set('FM', /(9694[1-4])([ \-]\d{4})?/);
    regexPostalCode.set('GF', /9[78]3\d{2}/);
    regexPostalCode.set('GN', /\d{3}/);
    regexPostalCode.set('GP', /9[78][01]\d{2}/);
    regexPostalCode.set('GS', /SIQQ 1ZZ/);
    regexPostalCode.set('GU', /969[123]\d([ \-]\d{4})?/);
    regexPostalCode.set('GW', /\d{4}/);
    regexPostalCode.set('HM', /\d{4}/);
    regexPostalCode.set('IQ', /\d{5}/);
    regexPostalCode.set('KG', /\d{6}/);
    regexPostalCode.set('LR', /\d{4}/);
    regexPostalCode.set('LS', /\d{3}/);
    regexPostalCode.set('MG', /\d{3}/);
    regexPostalCode.set('MH', /969[67]\d([ \-]\d{4})?/);
    regexPostalCode.set('MN', /\d{6}/);
    regexPostalCode.set('MP', /9695[012]([ \-]\d{4})?/);
    regexPostalCode.set('MQ', /9[78]2\d{2}/);
    regexPostalCode.set('NC', /988\d{2}/);
    regexPostalCode.set('NE', /\d{4}/);
    regexPostalCode.set('VI', /008(([0-4]\d)|(5[01]))([ \-]\d{4})?/);
    regexPostalCode.set('PF', /987\d{2}/);
    regexPostalCode.set('PG', /\d{3}/);
    regexPostalCode.set('PM', /9[78]5\d{2}/);
    regexPostalCode.set('PN', /PCRN 1ZZ/);
    regexPostalCode.set('PW', /96940/);
    regexPostalCode.set('RE', /9[78]4\d{2}/);
    regexPostalCode.set('SH', /(ASCN|STHL) 1ZZ/);
    regexPostalCode.set('SJ', /\d{4}/);
    regexPostalCode.set('SO', /\d{5}/);
    regexPostalCode.set('SZ', /[HLMS]\d{3}/);
    regexPostalCode.set('TC', /TKCA 1ZZ/);
    regexPostalCode.set('WF', /986\d{2}/);
    regexPostalCode.set('XK', /\d{5}/);
    regexPostalCode.set('YT', /976\d{2}/);
  }

  setInfoFromBVR(info: string) {
    this.infoSource = InputInfoSource.BVR;
    // 2 8 2 1 > 7 19 1 + 9
    // 0100000027051 > 000000100000000000000000011 + 000000001>
    // 2 8 2 1 > 16 + 9 Sans référence
    // 0100000027051 > 0000000000000001 + 010044912>
    // 0100000027051 > 0000000000000001 + 000000001>
    let matches = info.match(/([^>]*)(?=>)/);
    let part1;
    let part2;
    let part3;
    if (matches && matches[0] && matches[0].length > 0) {
      part1 = matches[0];
    }
    matches = info.match(/(>[^\+]*)(?=\+)/);
    if (matches && matches[0] && matches[0].length > 0) {
      part2 = matches[0].substring(1);
    }
    matches = info.match(/(\+[^>]*)(?=>)/);
    if (matches && matches[0] && matches[0].length > 0) {
      part3 = matches[0].substring(1);
    }
    if (part1 && part1.length === 13) {
      const stringAmount =
        part1.substring(2, part1.length - 3) + '.' + part1.substring(part1.length - 3, part1.length - 1);
      this.amountToPay = stringAmount && stringAmount.replace ? parseFloat(stringAmount.replace(',', '.')) : 0;
    }
    if (part2 && part2.length >= 16) {
      if (part2.length === 27) {
        this.xxReference = part2.substring(0, 7);
      }
      this.bvr = part2;
    }
    if (part3 && part3.length === 9) {
      this.bankAccountId = part3;
    }
    if (this.bvr === undefined || this.bankAccountId === undefined) {
      this.errors.push('bvrCodeInvalid');
    }
    this.currency = 'CHF';
  }

  setInfoFromQR(info: string[]) {
    this.infoSource = InputInfoSource.QR;
    if (info[3] && info[3].trim() !== '') {
      this.IBAN = info[3].trim();
      if (!isIBANValid(this.IBAN)) {
        this.errors.push('ibanInvalid');
      } else {
        const CheckIBanNB = parseInt(this.IBAN.substring(4, 4 + 5), 10);
        if (29999 < CheckIBanNB && CheckIBanNB < 32000) {
          this.QRIBAN = this.IBAN;
          this.IBAN = null;
        }
      }
    } else {
      this.errors.push('iban');
    }
    if (info[5] && info[5].trim() !== '') {
      this.vendorName = info[5].trim();
    } else {
      this.errors.push('vendorName');
    }
    // country
    let regexPC;
    if (info[10] && info[10].trim() !== '') {
      this.countryCode = info[10].trim();
      regexPC = regexPostalCode.get(this.countryCode);
    } else {
      this.errors.push('countryCode');
    }
    let i = 9;
    if (regexPC) {
      let findPostal = false;
      let findCity = false;
      while (i > 6 && (!findPostal || !findCity)) {
        if (info[i] && info[i].trim() !== '') {
          if (!findPostal && info[i].trim().match(regexPC)) {
            this.postalCode = info[i].trim().match(regexPC)[0];
            findPostal = true;
            if (info[i].trim().replace(this.postalCode, '') !== '') {
              this.city = info[i].trim().replace(this.postalCode, '').trim();
              findCity = true;
            }
          } else if (!findCity) {
            this.city = info[i].trim();
            findCity = true;
          }
        }
        i--;
      }
    } else {
      this.errors.push('postalCode');
      this.errors.push('city');
    }
    if (!this.postalCode) {
      this.errors.push('postalCode');
    }
    if (!this.city) {
      this.errors.push('city');
    }
    if (info[6] && info[6].trim() !== '') {
      this.address1 = info[6].trim();
    } else {
      this.address1 = null;
      // this.errors.push('address1');
    }
    // address2
    if (i > 6 && info[7] && info[7].trim() != '') {
      this.address2 = info[7] ? info[7].trim() : null;
    } else {
      this.address2 = null;
    }

    // currency
    if (info[19] && info[19].trim() !== '') {
      this.currency = info[19].trim();
    }
    // amount to pay
    if (info[18] && info[18].trim() !== '') {
      const value = info[18].trim();
      const floatValue = value && value.replace ? parseFloat(value.replace(',', '.')) : 0;
      if (Number.isNaN(floatValue) || floatValue === null) {
        this.amountToPay = 0;
      } else {
        this.amountToPay = floatValue;
      }
    }
    // bvr & vendorRef
    if (this.QRIBAN) {
      if (info[27] && info[27].trim() === 'QRR') {
        if (info[28] && info[28].trim() !== '') {
          this.bvr = info[28].trim();
        }

        if (info[29] && info[29].trim() !== '') {
          this.vendorRef = info[29].trim();
        } else if (info[31] && info[31].trim() !== '') {
          const arrayRef = info[31].trim().split('/');
          if (arrayRef.length > 4 && arrayRef[4] && arrayRef[4].trim() !== '') {
            this.vendorRef = arrayRef[4].trim();
          } else {
            this.vendorRef = info[31];
          }
        } else {
          this.warningvendorRefQr = true;
        }
      } else if (info[27] && info[27].trim() === 'SCOR') {
        this.isSCOR = true;
        if (info[28] && info[28].trim() !== '') {
          this.vendorRef = info[28] ? info[28].trim() : '';
        }
      } else {
        this.isSCOR = false;
        this.warningQRR = true;
      }
    } else if (info[27] && info[27].trim() === 'SCOR') {
      this.isSCOR = true;
      if (info[28] && info[28].trim() !== '') {
        this.vendorRef = info[28] ? info[28].trim() : '';
      }
    } else {
      this.isSCOR = false;
      if (info[28] && info[28].trim() !== '') {
        this.bvr = info[28].trim();
      }
      if (info[31] && info[31].trim() !== '') {
        this.vendorRef = info[31] ? info[31].trim() : '';
      }
    }
  }

  getCompleteAddress() {
    //  completeAddress
    return `${this.address1 ? this.address1 : ''}${this.address2 ? ', ' + this.address2 : ''}, ${
      this.postalCode ? this.postalCode : ''
    } ${this.city ? this.city : ''}${this.countryName ? ', ' + this.countryName : ''}`;
  }
}

export function getNullValueInData(data: any, columnNames: string[]) {
  let nullValue = null;
  for (const columnName of columnNames) {
    const value = data[columnName];
    if (
      value == null ||
      value == undefined ||
      value == '' ||
      (value.trim && value.trim() == '') ||
      (columnName === 'AD_Org_ID' && value.id <= 0)
    ) {
      nullValue = columnName;
      return;
    }
  }
  return nullValue;
}

export function isIBANValid(value: string): boolean {
  return IBAN.isValid(value);
}

export function getLineCustomDesignItems() {
  return [
    {
      vcr: 'vcrsCharge',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_Charge_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsProduct',
      type: CustomDesignItemType.FIELD,
      columnName: 'M_Product_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsQty',
      type: CustomDesignItemType.FIELD,
      columnName: 'QtyEntered',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsPriceEntered',
      type: CustomDesignItemType.FIELD,
      columnName: 'PriceEntered',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsPriceList',
      type: CustomDesignItemType.FIELD,
      columnName: 'PriceList',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsTax',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_Tax_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsTaxAmt',
      type: CustomDesignItemType.FIELD,
      columnName: 'TaxAmt',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsLineNetAmt',
      type: CustomDesignItemType.FIELD,
      columnName: 'LineNetAmt',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    // hidden fields for callout
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'IsSOTrx',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'PriceActual',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'Description',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'QtyInvoiced',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'PriceLimit',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'EnforcePriceLimit',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'TVAEncaissement',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_UOM_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'LineTotalAmt',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_InvoiceLine_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrsOthers',
      type: CustomDesignItemType.FIELD,
      columnName: 'IsDropShip',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
  ];
}

export function getHeaderCustomDesignItems() {
  return [
    {
      vcr: 'vcrCreateFrom',
      type: CustomDesignItemType.FIELD,
      columnName: 'CreateFrom',
      cssClass: 'createFrom',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrBPartner',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_BPartner_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrBPBankAccount',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_BP_BankAccount_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrValidator',
      type: CustomDesignItemType.FIELD,
      columnName: 'XX_Validator_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrBVR',
      type: CustomDesignItemType.FIELD,
      columnName: 'XX_BVR',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrPriceListHeader',
      type: CustomDesignItemType.FIELD,
      columnName: 'M_PriceList_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrPaymentTerm',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_PaymentTerm_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrBPartnerLocation',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_BPartner_Location_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrOrder',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_Order_ID',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrZ_PaymentCommunication',
      type: CustomDesignItemType.FIELD,
      columnName: 'Z_PaymentCommunication',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrDateInvoiced',
      type: CustomDesignItemType.FIELD,
      columnName: 'DateInvoiced',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrGrandTotal',
      type: CustomDesignItemType.FIELD,
      columnName: 'GrandTotal',
      cssClass: 'group-input',
      isLabelDisplay: false,
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'AD_Client_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'IsSOTrx',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_Invoice_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'AD_Org_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'DocumentNo',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'DateAcct',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'DateOrdered',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_DocTypeTarget_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_DocType_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'DocAction',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'AD_User_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'SalesRep_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'IsReturnTrx',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'DocStatus',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'C_Currency_ID',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrSettings',
      type: CustomDesignItemType.FIELD,
      columnName: 'PaymentRule',
      cssClass: 'group-input',
    },
    {
      vcr: 'vcrProcessInvoice',
      type: CustomDesignItemType.FIELD,
      columnName: 'Processing',
      cssClass: 'group-input',
    },
  ];
}
